import type { SupportedLanguage } from '../types';

export function getSupportedLanguage(language: string): SupportedLanguage {
  switch (language) {
    case 'en':
      return 'en';
    case 'id':
      return 'id';
    default:
      return 'en';
  }
}
